import { Col, Form, Row } from 'antd';
import React, { memo } from 'react';
import { CountrySelect } from '@xbcb/form-item-components';
import StateOrProvinceSelect from 'components/StateOrProvinceSelect';
import HelpLink from 'components/HelpLink/container';
import { StyledHelpLinkDiv } from 'components/LineItemManufacturerInfo/styles';
import { useWorkOrderTaskConfiguration } from 'libs/hooks';
import { isReadOnly, shouldRequire } from 'libs/readWriteControl';
import { CommercialInvoiceBaseProps } from 'types';

export interface LineItemCountrySelectProps extends CommercialInvoiceBaseProps {
  originCountryCode?: string;
}

/**
 * LineItemCountrySelect
 *
 */

export const LineItemCountrySelect: React.FC<LineItemCountrySelectProps> = ({
  fullNamePath,
  localNamePath,
  disabled,
  originCountryCode,
  readOnly,
  required,
}) => {
  const form = Form.useFormInstance();
  const { readWriteControlsConfig } = useWorkOrderTaskConfiguration();
  return (
    <Row>
      <Col>
        <CountrySelect
          disabled={disabled}
          readOnly={
            readOnly ||
            isReadOnly(
              'invoices.products.lines.origin',
              readWriteControlsConfig,
            )
          }
          required={shouldRequire(
            'invoices.products.lines.origin',
            readWriteControlsConfig,
            required,
          )}
          localNamePath={[...localNamePath, 'origin', 'countryCode']}
          label="Origin Country"
          onChange={() => {
            // stateCode is only for Canada thus we should clear it onChange
            form.setFields([
              {
                name: [...fullNamePath, 'origin', 'stateCode'],
                value: undefined,
              },
            ]);
          }}
          notAllowedCountryCodes={['BY']}
        />
        <StyledHelpLinkDiv>
          <HelpLink
            link="https://help.inlt.com/customs-brokerage/determining-country-of-origin"
            text="Determining country of origin"
          />
        </StyledHelpLinkDiv>
      </Col>
      <Col>
        {originCountryCode === 'CA' && (
          <StateOrProvinceSelect
            // If the select is shown (i.e. `CA` `countryCode` is
            // selected), it is required
            required
            disabled={disabled}
            readOnly={readOnly}
            localNamePath={[...localNamePath, 'origin', 'stateCode']}
            label={'Canadian Province'}
            codesPath={'ISO.country.alpha2.CA.subdivision'}
          />
        )}
      </Col>
    </Row>
  );
};

export default memo(LineItemCountrySelect);
